import React from 'react';
import PropTypes from 'prop-types';
import { disseminationLevel } from '../../constants/parameters';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Table, Button, Popconfirm } from 'antd';
import { TableRowActions } from '../';

const DisseminationLevelTable = ({
  dataSource,
  t,
  deleteClassifier,
  showModal,
}) => {
  const columns = [
    {
      title: t('tableGeneral.code'),
      dataIndex: disseminationLevel.CODE,
    },
    {
      title: t('tableGeneral.en'),
      dataIndex: [disseminationLevel.LANG, disseminationLevel.ENGLISH],
    },
    {
      title: t('tableGeneral.et'),
      dataIndex: [disseminationLevel.LANG, disseminationLevel.ESTONIAN],
    },
    {
      title: t('tableGeneral.actions'),
      render: (value) => (
        <TableRowActions>
          <Button
            shape="circle"
            icon={<EditOutlined />}
            size="small"
            type="primary"
            onClick={() => showModal(value[disseminationLevel.CODE])}
          />
          <span className="ant-divider" />
          <Popconfirm
            title={t('popconfirm.title')}
            onConfirm={() => deleteClassifier(value[disseminationLevel.CODE])}
            okText={t('popconfirm.buttonYes')}
            cancelText={t('popconfirm.buttonNo')}
          >
            <Button
              shape="circle"
              icon={<DeleteOutlined />}
              size="small"
              type="primary"
            />
          </Popconfirm>
        </TableRowActions>
      ),
    },
  ];

  return (
    <Table
      rowKey={disseminationLevel.CODE}
      dataSource={dataSource}
      columns={columns}
      pagination={false}
    />
  );
};

DisseminationLevelTable.propTypes = {
  dataSource: PropTypes.array,
  t: PropTypes.func.isRequired,
  deleteClassifier: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
};

export default DisseminationLevelTable;
